import { render } from "./reject-btn.vue?vue&type=template&id=0b818280&scoped=true"
import script from "./reject-btn.vue?vue&type=script&lang=js"
export * from "./reject-btn.vue?vue&type=script&lang=js"

import "./reject-btn.vue?vue&type=style&index=0&id=0b818280&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b818280"]])

export default __exports__